export default __webpack_public_path__ + "static/media/mg-img.96e0d7ff.webp";